<div class="gracias-container">
    <div class="gracias-content">
        <h1 class="gracias-title">¡Gracias por contactarte con nosotros!</h1>
        <p class="gracias-message">A la brevedad un representate se comunicará con vos.</p>
        <p class="gracias-horario">Horario de atención: lunes a viernes de 9 a 18 hs.</p>
        <button class="return-button" (click)="volverAlInicio()">Volver al inicio</button>
    </div>
</div> 